import { createActions } from 'redux-actions';


const actionCreators = createActions({
    UI: {
        FLASH: {
            INFO: data => ({ type: 'info', ...data }),

            SUCCESS: data => ({ type: 'success', ...data }),

            WARN: data => ({ type: 'warning', ...data }),

            ERROR: data => ({ type: 'error', ...data }),

            REMOVE: id => id,
        },

        DATA_LOADING: {
            ON: name => ({ name }),
            OFF: name => ({ name }),
            FAIL: name => ({ name }),
            DESTROY: name => ({ name }),

            DATA: {
                SET: (name, data) => ({ name, data }),
            },
        },

        SIDEBAR: {
            TOGGLE: undefined,
            SHOW: undefined,
            HIDE: undefined,
        },

        NAVBAR: {
            SET_HEIGHT: navbarRef => navbarRef,
        },
    },
});

export default actionCreators.ui;
